module.exports = __webpack_public_path__ + "static/media/checked.7377a368.svg";